import { z } from 'zod'

import { AppLogStatus, AppLogType } from '../constants/appLog'
import { EmailTemplate } from '../constants/email'
import { dbEntitySchema, listQueryZodFields } from './system'

export const appLogEmailDataSchema = z.object({
  template: z.nativeEnum(EmailTemplate),
  recipientEmail: z.string(),
  recipientName: z.string().optional().nullable(),
  subject: z.string(),
  fromAddress: z.string(),
  hasAttachments: z.boolean(),
  html: z.string().optional().nullable(),
  configurationSet: z.string().optional().nullable(),
  sesMessageId: z.string().optional().nullable(),
  errorCode: z.string().optional().nullable(),
  errorMessage: z.string().optional().nullable(),
  context: z.record(z.string(), z.string()).optional(),
})

export const appLogSesEventDataSchema = z.object({
  eventType: z.enum(['OPEN', 'BOUNCE']),
  sesNotificationType: z.enum(['Open', 'Bounce']),
  messageId: z.string(),
  topicArn: z.string(),
  source: z.string().optional().nullable(),
  destinations: z.array(z.string()),
  recipientEmail: z.string().optional().nullable(),
  bounceType: z.string().optional().nullable(),
  processedAt: z.coerce.date(),
  context: z.record(z.string(), z.string()).optional(),
})

const appLogBaseSchema = dbEntitySchema.extend({
  status: z.nativeEnum(AppLogStatus),
  summary: z.string(),
})

const appLogEmailSchema = appLogBaseSchema.extend({
  type: z.literal(AppLogType.EMAIL),
  data: appLogEmailDataSchema,
})

const appLogSesEventSchema = appLogBaseSchema.extend({
  type: z.literal(AppLogType.SES_EVENT),
  data: appLogSesEventDataSchema,
})

export const appLogSchema = z.discriminatedUnion('type', [
  appLogEmailSchema,
  appLogSesEventSchema,
])

export const appLogListEmailDataSchema = appLogEmailDataSchema.omit({
  html: true,
})

export const appLogListItemSchema = z.discriminatedUnion('type', [
  appLogEmailSchema.extend({
    data: appLogListEmailDataSchema,
  }),
  appLogSesEventSchema,
])

export const appLogEmailRecordSchema = z.object({
  status: z.nativeEnum(AppLogStatus),
  template: z.nativeEnum(EmailTemplate),
  recipientEmail: z.string(),
  recipientName: z.string().optional().nullable(),
  subject: z.string(),
  fromAddress: z.string(),
  hasAttachments: z.boolean(),
  html: z.string().optional().nullable(),
  configurationSet: z.string().optional().nullable(),
  sesMessageId: z.string().optional().nullable(),
  errorCode: z.string().optional().nullable(),
  errorMessage: z.string().optional().nullable(),
  context: z.record(z.string(), z.string()).optional(),
})

export const appLogSesEventRecordSchema = z.object({
  eventType: z.enum(['OPEN', 'BOUNCE']),
  sesNotificationType: z.enum(['Open', 'Bounce']),
  messageId: z.string(),
  topicArn: z.string(),
  source: z.string().optional().nullable(),
  destinations: z.array(z.string()),
  recipientEmail: z.string().optional().nullable(),
  bounceType: z.string().optional().nullable(),
  processedAt: z.coerce.date().optional(),
  context: z.record(z.string(), z.string()).optional(),
  status: z.nativeEnum(AppLogStatus).optional(),
})

export const appLogsListQuerySchema = z.object({
  ...listQueryZodFields,
  search: z.string().optional(),
  bookingId: z.string().optional(),
  type: z.nativeEnum(AppLogType).optional().nullable(),
  status: z.nativeEnum(AppLogStatus).optional().nullable(),
  createdStart: z.coerce.date().optional(),
  createdEnd: z.coerce.date().optional(),
})

export const appLogsListResponseSchema = z.object({
  data: z.array(appLogListItemSchema),
})
